
import axios from "@/config/http.js"
import api from  "@/config/api.js"
import Vue from 'vue'
export default {
	state:{		
	},
	mutations:{
		setAdinfo(state,data){
			if(data){
				for(let k in data){
					Vue.set(state,k,data[k]);
				}
			}			
		}
	},
	getters: {
		getAds(state){
			return (key)=>{
				if(key){
					return state[key];
				}
				return state;
			}
		}
	},
	actions: {
		getAdinfo({commit},params){
			return axios.post(api.ajaxadInfo,params).then((res)=>{
				if(res && res.code == 200){
					commit("setAdinfo",res.data);
				}				
			})
		}
	}
}